import { Component, input } from '@angular/core';
import { PasswordPolicy } from '@ebeihilfe/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'portal-progress-bar',
  templateUrl: 'progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  imports: [TranslateModule],
})
export class ProgressBarComponent {
  public value = input.required<string>();
  public rules = input.required<PasswordPolicy[]>();
  public minimumLength = input<number>();
  public maximumLength = input<number>();

  public get length(): number {
    return this.value()?.length ?? 0;
  }

  public isRuleMatched(rule: PasswordPolicy): boolean {
    const pattern = rule.pattern instanceof RegExp ? rule.pattern : new RegExp(rule.pattern);
    return pattern.test(this.value() || '');
  }
}
